<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="http://jonquilit.com">
            jonquil it Team
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://jonquilit.com">
            Blog
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://www.wonpager.com">
            Copyright © 2017 WONpager ® | All Rights Reserved
          </a>
        </li>
      </ul>
      <div class="copyright">
        © {{year}} made with <i class="tim-icons icon-heart-2"></i> by
        <a href="http://jonquilit.com" target="_blank" rel="noopener">Jonquil informatique & Technology </a>&nbsp; 
        <a href="http://jonquilit.com" target="_blank" rel="noopener">Engineering</a> team
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style>
</style>
